import React from 'react';
import {
  APPLICATION_STATUS_LIST,
  APPLY_METHOD_TYPE_LIST,
  CITIZENSHIP_TYPE_LIST,
  DEFAULT_STATUS_LIST,
  DELIVERY_METHOD_EXTRACTS_TYPE_LIST,
  DELIVERY_METHOD_TYPE_LIST,
  DOCUMENT_IS_ACTUAL_LIST,
  DOCUMENT_STATUS_LIST,
  DOCUMENT_SUBMISSION_TYPE_LIST,
  ECOLOGY_CLASS_TYPE_LIST,
  GENDER_OPTIONS,
  IDENTITY_TYPE_LIST,
  IN_REGISTRY_LIST,
  IN_REQUEST_INF_STATUS_LIST,
  IN_REQUEST_INF_TYPE_ENUM_LIST,
  LAST_UPDATE_LIST,
  NOTIFICATION_METHOD_TYPE_LIST,
  OWNERSHIP_TYPE_LIST,
  PROCEDURE_TYPE_LIST,
  SPEED_LIST,
  SUBJECT_TYPE_LIST_FILTER,
  SUBJECT_TYPE_ONLY_REGISTRY_LIST,
  TRAVEL_TIME_LIST,
  USER_TYPE,
  USER_TYPE_LIST,
  VALIDITY_LICENSES_LIST,
  VEHICLE_REGISTRY_PRESENCE_LIST,
  VIOLATION_STATUS_LIST,
  WORK_REST_VIOLATION_TYPE_LIST,
} from '../../../configs';

import ApplicationsDTO from '../../../dto/ApplicationsDTO';
import RepresentativeDTO from '../../../dto/RepresentativeDTO';
import ApplicantDTO from '../../../dto/ApplicantDTO';
import InsurerDTO from '../../../dto/InsurerDTO';
import CarrierDTO from '../../../dto/CarrierDTO';
import SZLTDTO from '../../../dto/SZLTDTO';
import CarDTO from '../../../dto/CarDTO';
import VehiclesDTO from '../../../dto/VehiclesDTO';
import VisitDTO from '../../../dto/VisitsDTO';
import VehicleRegistryDTO from '../../../dto/VehicleRegistryDTO';
import ViolationDTO from '../../../dto/ViolationDTO';
import WayBillDTO from '../../../dto/WayBillDTO';
import UserActionLogDTO from '../../../dto/UserActionLogDTO';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { loadUserList } from '../../User/actions';
import InformationDTO from '../../../dto/InformationDTO';

const DTO = new ApplicationsDTO();
const attributes = DTO.getAttributesByName(false);
const representativeDto = new RepresentativeDTO();
const representativeAttributes = representativeDto.getAttributesByName(false);
const applicantDTO = new ApplicantDTO();
const applicantAttributes = applicantDTO.getAttributesByName(false);
const insurerDTO = new InsurerDTO();
const insurerAttributes = insurerDTO.getAttributesByName(false);
const carrierDTO = new CarrierDTO();
const carrierAttributes = carrierDTO.getAttributesByName(false);
const szltDTO = new SZLTDTO();
const szltAttributes = szltDTO.getAttributesByName(false);
const carDTO = new CarDTO();
const carAttributes = carDTO.getAttributesByName(false);
const vehiclesDto = new VehiclesDTO();
const vehiclesAttributes = vehiclesDto.getAttributesByName(false);
const visitDto = new VisitDTO();
const visitAttributes = visitDto.getAttributesByName(false);
const vehicleRegistryDto = new VehicleRegistryDTO();
const vehicleRegistryAttributes = vehicleRegistryDto.getAttributesByName(false);
const violationDto = new ViolationDTO();
const violationAttributes = violationDto.getAttributesByName(false);
const wayBillDto = new WayBillDTO();
const wayBillDtoAttributes = wayBillDto.getAttributesByName(false);
const userActionLogDto = new UserActionLogDTO();
const userActionLogAttributes = userActionLogDto.getAttributesByName();
const informationDTO = new InformationDTO();
const informationAttributes = informationDTO.getAttributesByName();

const datePicker = {
  component: 'DatePicker',
  usePortal: true,
  withLabel: true,
  variant: 'material',
  changeFormat: 'YYYY-MM-DD',
};

const rangeDatePicker = {
  component: 'RangeDatePicker',
  usePortal: true,
  withLabel: true,
  variant: 'material',
};

const rowRangeDatePicker = {
  component: 'RangeDatePicker',
  usePortal: true,
  className: 'no-border',
};

const dateTimePicker = {
  component: 'DateTimePicker',
  withLabel: true,
  variant: 'material',
};

const textInput = {
  component: 'TextInputWithLabel',
  variant: 'material',
};

const rowTextInput = {
  component: 'TextInput',
  className: 'no-border',
};

const multiTextInput = {
  component: 'MultiTextInput',
  variant: 'material',
  withLabel: true,
};

const customSelectInput = {
  component: 'CustomSelectInput',
  usePortal: true,
  withLabel: true,
  variant: 'material',
  addPlaceholder: true,
  multiple: true,
};

const rowCustomSelectInput = {
  component: 'CustomSelectInput',
  usePortal: true,
  className: 'no-border',
  addPlaceholder: true,
  multiple: true,
};

const rowCustomSelectInputWithHelper = {
  component: 'CustomSelectInputWithHelper',
  className: 'no-border',
  addPlaceholder: true,
  usePortal: true,
  multiple: true,
};

export const applicantFilter = [
  {
    dto: applicantAttributes.last_name,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.first_name,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.middle_name,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.birth_date,
    ...rangeDatePicker,
    changeFormat: 'YYYY-MM-DD',
  },
  {
    dto: applicantAttributes.gender,
    ...customSelectInput,
    placeholder: 'Пол',
    options: GENDER_OPTIONS,
  },
  {
    dto: applicantAttributes.citizenship,
    ...customSelectInput,
    placeholder: 'Гражданство',
    options: CITIZENSHIP_TYPE_LIST,
  },
  {
    dto: applicantAttributes.place_of_birth,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.snils,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.inn,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.ogrn,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.phone,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.email,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.identity_type,
    ...customSelectInput,
    placeholder: 'Тип документа, удостоверяющего личность',
    options: IDENTITY_TYPE_LIST,
  },
  {
    dto: applicantAttributes.identity_series,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.identity_number,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.identity_issue_date,
    ...rangeDatePicker,
    changeFormat: 'YYYY-MM-DD',
  },
  {
    dto: applicantAttributes.identity_issuer,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.address,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.commercial_name,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.logo_files,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.legal_entity_form,
    ...multiTextInput,
    // component: 'CustomSelectInputWithHelper',
    // variant: 'material',
    // usePortal: true,
    // withLabel: true,
    // multiple: true,
    // portalClassName: 'executor-selector',
    // loadAction: 'loadLegalEntityFormList',
    // optionFormatter: 'full_name_full_name',
  },
  {
    dto: applicantAttributes.short_name,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.full_name,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.legal_address,
    ...multiTextInput,
  },
];

export const insuranceFilter = [
  {
    dto: insurerAttributes.insurer,
    ...multiTextInput,
  },
  {
    dto: insurerAttributes.insurance_contract_series,
    ...multiTextInput,
  },
  {
    dto: insurerAttributes.insurance_contract_number,
    ...multiTextInput,
  },
  {
    dto: insurerAttributes.insurance_contract_effective_date,
    ...rangeDatePicker,
    changeFormat: 'YYYY-MM-DD',
  },
  {
    dto: insurerAttributes.insurance_contract_expiration_date,
    ...rangeDatePicker,
    changeFormat: 'YYYY-MM-DD',
  },
];

export const carFilter = [
  {
    dto: carAttributes.vehicle_brand,
    ...multiTextInput,
    placeholder: '',
  },
  {
    dto: carAttributes.vehicle_model,
    ...multiTextInput,
  },
  {
    dto: carAttributes.vehicle_year,
    ...customSelectInput,
    options: Array.from({ length: new Date().getFullYear() - 1899 }, (_, i) => ({
      value: new Date().getFullYear() - i,
      name: `${new Date().getFullYear() - i}`,
    })),
  },
  {
    dto: carAttributes.vehicle_color,
    ...multiTextInput,
  },
  {
    dto: carAttributes.vehicle_lpn,
    ...multiTextInput,
  },
  {
    dto: carAttributes.vehicle_vin,
    ...multiTextInput,
  },
  {
    dto: carAttributes.vehicle_registration_number,
    ...multiTextInput,
  },
  {
    dto: carAttributes.vehicle_registration_issue_date,
    ...rangeDatePicker,
    changeFormat: 'YYYY-MM-DD',
  },
  {
    dto: carAttributes.ecology_class,
    ...customSelectInput,
    placeholder: 'Экологический класс',
    options: ECOLOGY_CLASS_TYPE_LIST,
  },
  {
    dto: carAttributes.has_special_lifting_device,
    ...customSelectInput,
    placeholder: 'Наличие специального подъемного устройства',
    options: [{ value: true, name: 'Да' }, { value: false, name: 'Нет' }],
  },
  {
    dto: carAttributes.ownership_type,
    ...customSelectInput,
    placeholder: 'Основание владения',
    options: OWNERSHIP_TYPE_LIST,
  },
  {
    dto: carAttributes.ownership_contract_number,
    ...multiTextInput,
  },
  {
    dto: carAttributes.ownership_contract_effective_date,
    ...rangeDatePicker,
    changeFormat: 'YYYY-MM-DD',
  },
  {
    dto: carAttributes.ownership_contract_expiration_date,
    ...rangeDatePicker,
    changeFormat: 'YYYY-MM-DD',
  },
];

export const driverFilter = [
  {
    dto: carrierAttributes.has_employees,
    ...customSelectInput,
    placeholder: 'Наличие наёмного работника',
    options: [{ value: true, name: 'Да' }, { value: false, name: 'Нет' }],
  },
  {
    dto: carrierAttributes.driver_license_series,
    ...multiTextInput,
  },
  {
    dto: carrierAttributes.driver_license_number,
    ...multiTextInput,
  },
  {
    dto: carrierAttributes.driver_license_issue_date,
    ...rangeDatePicker,
    changeFormat: 'YYYY-MM-DD',
  },
  {
    dto: carrierAttributes.driver_license_expiration_date,
    ...rangeDatePicker,
    changeFormat: 'YYYY-MM-DD',
  },
  {
    dto: carrierAttributes.medical_examination_address,
    ...multiTextInput,
  },
  {
    dto: carrierAttributes.decision,
    ...multiTextInput,
  },
  {
    dto: carrierAttributes.decision_date,
    ...rangeDatePicker,
    changeFormat: 'YYYY-MM-DD',
  },
];

export const carrierSzltFilter = [
  {
    dto: carrierAttributes.order_services_attach_order_service_number,
    component: 'RegistryNumberSelector',
    variant: 'material',
    addPlaceholder: true,
    placeholder: 'Наличие наёмного работника',
    withLabel: true,
    loadAction: 'szltHelper',
  },
  {
    dto: carrierAttributes.order_services_attach_contract_number,
    ...multiTextInput,
  },
  {
    dto: carrierAttributes.order_services_attach_contract_effective_date,
    ...rangeDatePicker,
    changeFormat: 'YYYY-MM-DD',
  },
  {
    dto: carrierAttributes.order_services_attach_contract_expiration_date,
    ...rangeDatePicker,
    changeFormat: 'YYYY-MM-DD',
  },
];

export const applicationSzltFilter = [
  {
    dto: szltAttributes.web_site,
    ...multiTextInput,
  },
  {
    dto: szltAttributes.order_receiving_methods,
    ...multiTextInput,
  },
  {
    dto: szltAttributes.software_names,
    ...multiTextInput,
  },
  {
    dto: szltAttributes.database_address,
    ...multiTextInput,
  },
  {
    dto: szltAttributes.server_address,
    ...multiTextInput,
  },
];

export const rowFilterSettings = [
  {
    dto: {
      name: 'search',
      labelKey: 'search',
    },
    component: 'TextSearchInput',
    className: 'no-border',
    withLabel: false,
  },
  {
    dto: attributes.procedure,
    ...customSelectInput,
    className: 'no-border',
    multiple: true,
    options: PROCEDURE_TYPE_LIST,
    portalClassName: 'procedure-selector',
    withLabel: false,
  },
  {
    dto: attributes.executor_id,
    component: 'CustomSelectInputWithHelper',
    usePortal: true,
    multiple: true,
    options: PROCEDURE_TYPE_LIST,
    portalClassName: 'executor-selector',
    loadAction: 'loadUserList',
    optionFormatter: 'id_full_name',
    filterName: 'full_name',
    withLabel: false,
  },
  {
    ...customSelectInput,
    dto: attributes.status,
    className: 'no-border',
    multiple: true,
    placeholder: 'Статус',
    options: APPLICATION_STATUS_LIST,
    withLabel: false,
  },
  {
    component: 'RangeDatePicker',
    dto: attributes.created_at,
    className: 'no-border',
    usePortal: true,
    placeholder: 'Дата подачи',
    changeFormat: 'YYYY-MM-DD',
    withLabel: false,
  },
];

export const applicationFilterSettings = [
  {
    groupName: 'Информация об обращении',
    id: 'group-1',
    children: [
      {
        dto: attributes.view_mode,
        ...customSelectInput,
        multiple: false,
        placeholder: 'Отображение',
        options: [
          { value: 1, name: 'Все' },
          { value: 2, name: 'Активные' },
          { value: 3, name: 'Архивные' },
          { value: 4, name: 'Удалённые' },
        ],
      },
      {
        dto: attributes.mais_egu_id,
        ...multiTextInput,
      },
      {
        dto: attributes.apply_method,
        ...customSelectInput,
        placeholder: 'Способ подачи заявления',
        options: APPLY_METHOD_TYPE_LIST,
      },
      {
        dto: attributes.decided_at,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: attributes.consider_apply_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: attributes.applied_at,
        ...rangeDatePicker,
        onChangeToIso: true,
      },
      {
        dto: attributes.number,
        ...multiTextInput,
      },
      {
        dto: {
          ...attributes.document_submission_type,
          validators: [],
        },
        ...customSelectInput,
        placeholder: 'Форма подачи документов',
        options: DOCUMENT_SUBMISSION_TYPE_LIST,
      },
      {
        dto: attributes.procedure_conducting_authority,
        ...multiTextInput,
      },
      {
        dto: attributes.notification_violation_date,
        ...rangeDatePicker,
        onChangeToIso: true,
      },
      {
        dto: attributes.delivery_method_extracts_from_register,
        ...customSelectInput,
        placeholder: 'Способ направления выписки из реестра',
        options: DELIVERY_METHOD_EXTRACTS_TYPE_LIST,
      },
      {
        dto: attributes.delivery_method_notification,
        ...customSelectInput,
        placeholder: 'Способ направления уведомления о решении',
        options: DELIVERY_METHOD_TYPE_LIST,
      },
      {
        dto: attributes.notification_method,
        ...customSelectInput,
        placeholder: 'Способ уведомления о ходе предоставления услуги',
        options: NOTIFICATION_METHOD_TYPE_LIST,
      },
    ],
  },
  {
    groupName: 'Заявитель',
    id: 'group-2',
    namePrefix: 'applicant.',
    children: [
      {
        dto: applicantAttributes.legal_entity_type,
        ...customSelectInput,
        placeholder: 'Тип заявителя',
        options: USER_TYPE_LIST,
      },
      ...applicantFilter,
    ],
  },
  {
    groupName: 'Представитель',
    id: 'group-3',
    namePrefix: 'representative.',
    children: [
      {
        dto: representativeAttributes.document_of_authority,
        ...multiTextInput,
      },
      {
        dto: representativeAttributes.document_of_authority_number,
        ...multiTextInput,
      },
      {
        dto: representativeAttributes.document_of_authority_issue_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: representativeAttributes.document_of_authority_expiration_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: applicantAttributes.fact_address,
        ...multiTextInput,
      },
      ...(applicantFilter.filter(f => !['snils', 'inn', 'ogrn', 'commercial_name', 'logo_files', 'legal_entity_form', 'short_name', 'full_name', 'legal_address'].includes(f.dto.name))),
    ],
  },
  {
    groupName: 'Информация о разрешении',
    namePrefix: 'application_carrier.',
    id: 'group-4',
    children: [
      {
        dto: carrierAttributes.effective_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: carrierAttributes.expiration_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
    ],
  },
  {
    groupName: 'Информация по ОСГОП перевозчика',
    id: 'group-5',
    namePrefix: 'osgop_insurance.',
    labelPrefix: 'osgop_',
    children: [
      ...(insuranceFilter.filter(f => !['insurance_contract_series'].includes(f.dto.name))),
    ],
  },
  {
    groupName: 'Водительское удостоверение',
    id: 'group-6',
    namePrefix: 'application_carrier.',
    children: [...driverFilter.filter(f => !['medical_examination_address', 'decision', 'decision_date'].includes(f.dto.name))],
  },
  {
    groupName: 'Реестр СЗЛТ',
    id: 'group-7',
    namePrefix: 'application_carrier.',
    children: [...carrierSzltFilter],
  },
  {
    groupName: 'СЗЛТ исключить от перевозчика',
    id: 'group-8',
    namePrefix: 'application_carrier.',
    children: [
      {
        dto: carrierAttributes.order_service_numbers_detach,
        ...multiTextInput,
      },
    ],
  },
  {
    groupName: 'Номера в реестре ЛТ включить перевозчику',
    id: 'group-9',
    namePrefix: 'application_carrier.',
    children: [
      {
        dto: carrierAttributes.vehicle_numbers_attach,
        ...multiTextInput,
      },
    ],
  },
  {
    groupName: 'Номера в реестре ЛТ исключить от перевозчика',
    id: 'group-10',
    namePrefix: 'application_carrier.',
    children: [
      {
        dto: carrierAttributes.vehicle_numbers_detach,
        ...multiTextInput,
      },
    ],
  },
  {
    groupName: 'Дополнительная информация о СЗЛТ',
    id: 'group-11',
    namePrefix: 'application_order_service.',
    children: [...applicationSzltFilter],
  },
  // {
  //   groupName: 'Информация по ОСАГО владельца ТС',
  //   namePrefix: 'insurance.',
  //   children: [...insuranceFilter],
  // },
  {
    id: 'group-12',
    groupName: 'Информация о транспортном средстве',
    namePrefix: 'application_vehicle.',
    children: [...carFilter],
  },
];

const carrierFilter = [
  {
    dto: carrierAttributes.vehicle_brand,
    ...multiTextInput,
    placeholder: '',
  },
];

const registryFields = [
  {
    dto: carrierAttributes.view_mode,
    ...customSelectInput,
    multiple: false,
    placeholder: 'Отображение',
    options: [
      { value: 1, name: 'Все' },
      { value: 2, name: 'Активные' },
      { value: 3, name: 'Архивные' },
      { value: 4, name: 'Удалённые' },
    ],
  },
  {
    dto: carrierAttributes.number,
    ...multiTextInput,
  },
  {
    dto: carrierAttributes.full_name,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.inn,
    ...multiTextInput,
  },
  {
    dto: applicantAttributes.ogrn,
    ...multiTextInput,
  },
];

export const registryCarrierFilterSettings = [
  {
    id: 'group-13',
    groupName: 'Информация о перевозчике',
    children: [
      ...registryFields,
      {
        dto: carrierAttributes.effective_date,
        ...rangeDatePicker,
        hideTime: true,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: applicantAttributes.legal_entity_type,
        ...customSelectInput,
        placeholder: 'Тип заявителя',
        options: USER_TYPE_LIST.filter(f => f.value !== USER_TYPE.PRIVATE_PERSON_OLD),
      },
      ...(applicantFilter.filter(f => !['inn', 'ogrn', 'full_name'].includes(f.dto.name))),
    ],
  },
  {
    groupName: 'Информация о водители',
    id: 'group-14',
    // namePrefix: 'application_carrier.',
    children: driverFilter,
  },
  {
    groupName: 'Информация по ОСГОП перевозчика',
    id: 'group-15',
    // namePrefix: 'osgop_insurance.',
    labelPrefix: 'osgop_',
    children: [
      ...(insuranceFilter.filter(f => !['insurance_contract_series'].includes(f.dto.name))),
    ],
  },
  {
    groupName: 'Дополнительная информация',
    id: 'group-16',
    children: [
      {
        dto: carrierAttributes.carriage_contract_number,
        ...multiTextInput,
      },
      {
        dto: carrierAttributes.carriage_contract_effective_date,
        ...rangeDatePicker,
        hideTime: true,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: carrierAttributes.carriage_contract_expiration_date,
        ...rangeDatePicker,
        hideTime: true,
        changeFormat: 'YYYY-MM-DD',
      },
    ],
  },
  {
    groupName: 'Реестр СЗЛТ',
    id: 'group-17',
    children: [
      {
        dto: carrierAttributes.order_service_numbers,
        ...multiTextInput,
      },
    ],
  },
  {
    groupName: 'Реестр ЛТ',
    id: 'group-18',
    children: [
      {
        dto: carrierAttributes.vehicle_numbers_attach,
        ...multiTextInput,
      },
    ],
  },
];

export const passengerTaxiFilterSettings = [
  {
    groupName: 'Информация о реестровой записи',
    id: 'group-19',
    children: [
      ...registryFields,
    ],
  },
  {
    groupName: 'Информация о легковом такси',
    id: 'group-20',
    children: [
      {
        dto: vehiclesAttributes.vehicle_brand,
        ...multiTextInput,
      },
      {
        dto: vehiclesAttributes.vehicle_model,
        ...multiTextInput,
      },
      {
        dto: vehiclesAttributes.vehicle_year,
        ...customSelectInput,
        options: Array.from({ length: new Date().getFullYear() - 1899 }, (_, i) => ({
          value: new Date().getFullYear() - i,
          name: `${new Date().getFullYear() - i}`,
        })),
      },
      {
        dto: vehiclesAttributes.vehicle_color,
        ...multiTextInput,
      },
      {
        dto: vehiclesAttributes.vehicle_lpn,
        ...multiTextInput,
      },
      {
        dto: vehiclesAttributes.vehicle_vin,
        ...multiTextInput,
      },
      {
        dto: vehiclesAttributes.ecology_class,
        ...customSelectInput,
        placeholder: 'Экологический класс',
        options: ECOLOGY_CLASS_TYPE_LIST,
      },
      {
        dto: vehiclesAttributes.vehicle_registration_number,
        ...multiTextInput,
      },
      {
        dto: vehiclesAttributes.vehicle_registration_issue_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: vehiclesAttributes.has_special_lifting_device,
        ...customSelectInput,
        placeholder: 'Наличие специального подъемного устройства',
        options: [{ value: true, name: 'Да' }, { value: false, name: 'Нет' }],
      },
      {
        dto: vehiclesAttributes.technical_control_address,
        ...multiTextInput,
      },
      {
        dto: vehiclesAttributes.ownership_type,
        ...customSelectInput,
        placeholder: 'Основание владения',
        options: OWNERSHIP_TYPE_LIST,
      },
      {
        dto: vehiclesAttributes.ownership_contract_number,
        ...multiTextInput,
      },
      {
        dto: vehiclesAttributes.ownership_contract_effective_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: vehiclesAttributes.ownership_contract_expiration_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: vehiclesAttributes.effective_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
    ],
  },
  {
    groupName: 'Информация о заявителе',
    id: 'group-21',
    children: [
      {
        dto: applicantAttributes.legal_entity_type,
        ...customSelectInput,
        placeholder: 'Тип заявителя',
        options: USER_TYPE_LIST.filter(f => f.value !== USER_TYPE.PRIVATE_PERSON_OLD),
      },
      ...(applicantFilter.filter(f => !['inn', 'ogrn', 'commercial_name', 'logo_files'].includes(f.dto.name))),
    ],
  },
  {
    groupName: 'Информация о страховке',
    id: 'group-22',
    children: insuranceFilter,
  },
  {
    groupName: 'Дополнительная информация',
    id: 'group-23',
    children: [
      {
        dto: carrierAttributes.decision,
        ...multiTextInput,
      },
      {
        dto: carrierAttributes.decision_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
    ],
  },
];

export const szltFilterSettings = [
  {
    groupName: 'Информация о реестровой записи',
    id: 'group-24',
    children: [
      ...registryFields,
      {
        dto: szltAttributes.effective_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: szltAttributes.expiration_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
    ],
  },
  {
    groupName: 'Информация о заявителе',
    id: 'group-25',
    children: [
      {
        dto: applicantAttributes.legal_entity_type,
        ...customSelectInput,
        placeholder: 'Тип заявителя',
        options: USER_TYPE_LIST.filter(f => f.value !== USER_TYPE.PRIVATE_PERSON_OLD),
      },
      ...(applicantFilter.filter(f => !['inn', 'ogrn', 'commercial_name', 'logo_files'].includes(f.dto.name))),
    ],
  },
  {
    groupName: 'Информация о СЗЛТ',
    id: 'group-26',
    children: [
      ...applicationSzltFilter,
    ],
  },
  {
    groupName: 'Дополнительная информация',
    id: 'group-27',
    children: [
      {
        dto: szltAttributes.decision,
        ...multiTextInput,
      },
      {
        dto: szltAttributes.decision_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
    ],
  },
];

export const visitsFilterSettings = [
  {
    groupName: 'Основная информация',
    id: 'group-28',
    children: [
      {
        dto: visitAttributes.grn_ts,
        ...multiTextInput,
      },
      {
        dto: visitAttributes.trip_started_at,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: visitAttributes.trip_started_end,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: visitAttributes.trip_end_date_from,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: visitAttributes.trip_end_date_to,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: visitAttributes.start_point,
        ...multiTextInput,
      },
      {
        dto: visitAttributes.end_point,
        ...multiTextInput,
      },
      {
        dto: visitAttributes.intermediate_point,
        ...multiTextInput,
      },
      {
        dto: visitAttributes.trip_cost,
        ...multiTextInput,
      },
      {
        dto: visitAttributes.registry_presence,
        ...customSelectInput,
        placeholder: 'Наличие в реестрах',
        options: VEHICLE_REGISTRY_PRESENCE_LIST,
      },
      {
        dto: visitAttributes.driver_name,
        ...multiTextInput,
      },
      {
        dto: visitAttributes.carrier,
        ...multiTextInput,
      },
    ],
  },
];

export const vehicleRegistryFilterSettings = [
  {
    groupName: 'Основная информация',
    id: 'group-29',
    children: [
      {
        dto: vehicleRegistryAttributes.vehicle_lpn,
        ...multiTextInput,
      },
      {
        dto: vehicleRegistryAttributes.driver_name,
        ...multiTextInput,
      },
      {
        component: 'RangeDatePicker',
        dto: vehicleRegistryAttributes.start_date_time,
        usePortal: true,
        changeFormat: 'YYYY-MM-DD',
        variant: 'material',
        withLabel: true,
      },
      {
        dto: vehicleRegistryAttributes.vehicle_status,
        ...customSelectInput,
        options: DEFAULT_STATUS_LIST,
      },
      {
        dto: vehicleRegistryAttributes.last_update,
        ...customSelectInput,
        options: LAST_UPDATE_LIST,
      },
      {
        dto: vehicleRegistryAttributes.in_registry,
        ...customSelectInput,
        options: IN_REGISTRY_LIST,
      },
      {
        dto: vehicleRegistryAttributes.number,
        ...multiTextInput,
      },
      {
        dto: vehicleRegistryAttributes.validity_licenses,
        ...customSelectInput,
        options: VALIDITY_LICENSES_LIST,
      },
      {
        dto: vehicleRegistryAttributes.latitude_from,
        ...textInput,
        type: 'number',
      },
      {
        dto: vehicleRegistryAttributes.latitude_to,
        ...textInput,
        type: 'number',
      },
      {
        dto: vehicleRegistryAttributes.longitude_from,
        ...textInput,
        type: 'number',
      },
      {
        dto: vehicleRegistryAttributes.longitude_to,
        ...textInput,
        type: 'number',
      },
      {
        dto: vehicleRegistryAttributes.speed,
        ...customSelectInput,
        options: SPEED_LIST,
      },
      {
        dto: vehicleRegistryAttributes.total_travel_time,
        ...customSelectInput,
        options: TRAVEL_TIME_LIST,
      },
    ],
  },
];

export const violationsFilterSettings = [
  {
    groupName: 'Основная информация',
    id: 'group-30',
    children: [
      {
        dto: violationAttributes.status,
        ...customSelectInput,
        placeholder: '',
        multiple: false,
        options: VIOLATION_STATUS_LIST,
      },
      {
        dto: violationAttributes.violation_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: violationAttributes.resolution_at,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
    ],
  },
];

export const violationsControlWorkFilterSettings = [
  {
    groupName: 'Основная информация',
    id: 'group-36',
    children: [
      {
        dto: violationAttributes.carrier_name,
        ...multiTextInput,
      },
      {
        dto: violationAttributes.driver_license,
        ...multiTextInput,
      },
      {
        dto: violationAttributes.lpn,
        ...multiTextInput,
      },
      {
        dto: violationAttributes.type,
        ...customSelectInput,
        options: WORK_REST_VIOLATION_TYPE_LIST,
      },
      {
        dto: violationAttributes.violation_date,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
    ],
  },
];

export const waybillFilterSettings = [
  {
    groupName: 'Основная информация',
    id: 'group-31',
    children: [
      {
        dto: wayBillDtoAttributes.grn_ts,
        ...multiTextInput,
      },
      {
        dto: wayBillDtoAttributes.issue_created_at_to,
        ...dateTimePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: wayBillDtoAttributes.issue_created_at_from,
        ...dateTimePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: wayBillDtoAttributes.issue_valid_until_to,
        ...dateTimePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: wayBillDtoAttributes.issue_valid_until_from,
        ...dateTimePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: wayBillDtoAttributes.issue_start_to,
        ...dateTimePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: wayBillDtoAttributes.issue_start_from,
        ...dateTimePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: wayBillDtoAttributes.issue_end_to,
        ...dateTimePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: wayBillDtoAttributes.issue_end_from,
        ...dateTimePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: wayBillDtoAttributes.vehicle_brand,
        ...multiTextInput,
      },
      {
        dto: wayBillDtoAttributes.carrier,
        ...multiTextInput,
      },
    ],
  },
];

export const referenceUserActionFilterSettings = [
  {
    groupName: 'Быстрый поиск',
    id: 'group-32',
    children: [
      {
        dto: userActionLogAttributes.search,
        ...rowTextInput,
        inputBefore: (
          <div className="search-wrapper">
            <Icons customIcon className="search" width={24} height={24} icon="search" />
          </div>
        ),
      },
      {
        dto: userActionLogAttributes.causer_id,
        ...rowCustomSelectInputWithHelper,
        portalClassName: 'executor-selector',
        loadAction: 'loadUserList',
        optionFormatter: 'id_full_name',
        filterName: 'full_name',
      },
      {
        dto: userActionLogAttributes.subject_type,
        ...rowCustomSelectInput,
        options: SUBJECT_TYPE_LIST_FILTER,
      },
      {
        dto: userActionLogAttributes.created_at,
        ...rowRangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
        placeholder: 'Дата',
      },
    ],
  },
];

export const applicationDocumentsSettings = [
  {
    groupName: 'Быстрый поиск',
    id: 'group-33',
    children: [
      {
        dto: userActionLogAttributes.search,
        ...rowTextInput,
        inputBefore: (
          <div className="search-wrapper">
            <Icons customIcon className="search" width={24} height={24} icon="search" />
          </div>
        ),
      },
      {
        dto: attributes.procedure,
        ...rowCustomSelectInput,
        options: PROCEDURE_TYPE_LIST,
        portalClassName: 'procedure-selector',
      },
      {
        dto: attributes.creator_id,
        ...rowCustomSelectInputWithHelper,
        portalClassName: 'executor-selector',
        loadAction: 'loadUserList',
        optionFormatter: 'id_full_name',
        filterName: 'full_name',
      },
      {
        dto: attributes.status,
        ...rowCustomSelectInput,
        placeholder: 'Статус',
        options: DOCUMENT_STATUS_LIST,
        className: 'no-border short-size',
      },
      {
        dto: attributes.is_actual,
        ...rowCustomSelectInput,
        placeholder: 'Актуальность',
        options: DOCUMENT_IS_ACTUAL_LIST,
        className: 'no-border short-size',
      },
      {
        dto: attributes.created_at,
        ...rowRangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
        placeholder: 'Дата',
      },
    ],
  },
];

export const applicationHistorySettings = [
  {
    groupName: 'Быстрый поиск',
    id: 'group-34',
    children: [
      {
        dto: userActionLogAttributes.search,
        ...rowTextInput,
        inputBefore: (
          <div className="search-wrapper">
            <Icons customIcon className="search" width={24} height={24} icon="search" />
          </div>
        ),
      },
      {
        dto: userActionLogAttributes.causer_id,
        ...rowCustomSelectInputWithHelper,
        portalClassName: 'executor-selector',
        loadAction: 'loadUserList',
        optionFormatter: 'id_full_name',
        filterName: 'full_name',
      },
      {
        dto: attributes.created_at,
        ...rowRangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
        placeholder: 'Дата',
      },
    ],
  },
];

export const regionRegistryHistorySettings = [
  {
    groupName: 'Быстрый поиск',
    id: 'group-35',
    children: [
      {
        dto: userActionLogAttributes.search,
        ...rowTextInput,
        inputBefore: (
          <div className="search-wrapper">
            <Icons customIcon className="search" width={24} height={24} icon="search" />
          </div>
        ),
      },
      {
        dto: {
          name: 'subject_type',
          labelKey: 'subject_type',
        },
        ...rowCustomSelectInput,
        placeholder: 'Актуальность',
        options: SUBJECT_TYPE_ONLY_REGISTRY_LIST,
        className: 'no-border',
      },
      {
        dto: userActionLogAttributes.causer_id,
        ...rowCustomSelectInputWithHelper,
        portalClassName: 'executor-selector',
        loadAction: 'loadUserList',
        optionFormatter: 'id_full_name',
        filterName: 'full_name',
      },
      {
        dto: attributes.created_at,
        ...rowRangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
        placeholder: 'Дата',
      },
    ],
  },
];

export const informationFilterSettings = [
  {
    groupName: 'Основная информация',
    id: 'group-37',
    children: [
      {
        dto: informationAttributes.created_at,
        ...rangeDatePicker,
        changeFormat: 'YYYY-MM-DD',
      },
      {
        dto: informationAttributes.status,
        ...customSelectInput,
        options: IN_REQUEST_INF_STATUS_LIST,
      },
      {
        dto: informationAttributes.inf_type,
        ...customSelectInput,
        options: IN_REQUEST_INF_TYPE_ENUM_LIST,
      },
      {
        dto: informationAttributes.api_id,
        ...multiTextInput,
      },
      {
        dto: informationAttributes.inf_size,
        ...multiTextInput,
      },
    ],
  },
];

export const applicantFilterSettings = [
  {
    groupName: 'Основная информация',
    id: 'group-38',
    children: [
      ...(applicantFilter.filter(f => !['inn', 'ogrn', 'full_name', 'commercial_name', 'logo_files'].includes(f.dto.name))),
    ],
  },
];

export const PAGE_TYPE = {
  APPLICATION: 'application',
  APPLICANT: 'applicant',
  REGION_REGISTRY_CARRIER: 'region.registry.carrier',
  PASSENGER_TAXI: 'region.registry.passenger.taxi',
  SZLT: 'region.registry.szlt',
  VISITS: 'visits',
  VEHICLE_REGISTRY: 'vehicle.registry',
  VIOLATIONS: 'violations',
  VIOLATIONS_WORK_CONTROL: 'violations_control_work',
  WAYBILL: 'waybill',
  REFERENCE_USER_ACTION: 'reference.user.action',
  APPLICATION_DOCUMENTS: 'application.documents',
  APPLICATION_HISTORY: 'application.history',
  REGION_REGISTRY_HISTORY: 'region.registry.history',
  INFORMATION: 'information',
};

export const PAGE_TYPE_LIST = [
  { value: PAGE_TYPE.APPLICATION, nameId: 'menu.application', filter: applicationFilterSettings },
  { value: PAGE_TYPE.REGION_REGISTRY_CARRIER, nameId: 'menu.region.registry.carrier', filter: registryCarrierFilterSettings },
  { value: PAGE_TYPE.PASSENGER_TAXI, nameId: 'menu.region.registry.passenger.taxi', filter: passengerTaxiFilterSettings },
  { value: PAGE_TYPE.SZLT, nameId: 'menu.region.registry.szlt', filter: szltFilterSettings },
  { value: PAGE_TYPE.VISITS, nameId: 'menu.visits', filter: visitsFilterSettings },
  { value: PAGE_TYPE.VEHICLE_REGISTRY, nameId: 'menu.vehicle.registry', filter: vehicleRegistryFilterSettings },
  { value: PAGE_TYPE.VIOLATIONS, nameId: 'menu.violations_admin', filter: violationsFilterSettings },
  { value: PAGE_TYPE.WAYBILL, nameId: 'menu.waybill', filter: waybillFilterSettings },
  { value: PAGE_TYPE.REFERENCE_USER_ACTION, nameId: 'menu.reference.user.action', filter: referenceUserActionFilterSettings },
  { value: PAGE_TYPE.APPLICATION_DOCUMENTS, nameId: 'menu.application.documents', filter: applicationDocumentsSettings },
  { value: PAGE_TYPE.APPLICATION_HISTORY, nameId: 'menu.application.history', filter: applicationHistorySettings },
  { value: PAGE_TYPE.REGION_REGISTRY_HISTORY, nameId: 'menu.region.registry.history', filter: regionRegistryHistorySettings },
  { value: PAGE_TYPE.VIOLATIONS_WORK_CONTROL, nameId: 'menu.violations_control_work', filter: violationsControlWorkFilterSettings },
  { value: PAGE_TYPE.INFORMATION, nameId: 'menu.information', filter: informationFilterSettings },
  { value: PAGE_TYPE.APPLICANT, nameId: 'menu.applicant', filter: applicantFilterSettings },
];
